module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-intro-AFTER-trail.4d5dd4a0.mp3";